(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upr-mode-dial"] && !Shopify.designMode) return;
  try {
    
  /* Defined as a custom element rather than an inline script inside the
     section. The theme editor replaces a section's markup on every settings
     change, and inline scripts written in that way never re-execute — the dial
     would go dead until the merchant reloaded the page. A custom element
     upgrades itself every time it is inserted, however many times that is. */
  if (!customElements.get('upr-mode-dial')) {
    customElements.define(
      'upr-mode-dial',
      class UprModeDial extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;

          this.positions = Array.from(this.querySelectorAll('.upr-dial__pos'));
          this.panels = Array.from(this.querySelectorAll('.upr-dial__panel'));
          this.pointer = this.querySelector('.upr-dial__pointer');
          if (!this.positions.length || !this.panels.length) return;

          this.dataset.ready = 'true';
          this.classList.add('upr-dial--js');

          /* Touch screens fire a one-off mouseenter on tap and then keep :hover
             stuck on the last thing touched. Selecting on hover there would
             leave two markers looking active, so pointers that cannot really
             hover get click and focus only. */
          this.canHover = !!(
            window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches
          );

          /* Arrow keys walk the wheel in the order the positions physically sit
             on it, which is not necessarily the order the blocks were added. */
          this.ring = this.positions.slice().sort(function (a, b) {
            return parseFloat(a.dataset.angle) - parseFloat(b.dataset.angle);
          });

          const start = parseInt(this.dataset.defaultMode, 10) || 0;
          const startPos = this.positions.find(function (pos) {
            return pos.dataset.mode === String(start);
          });

          /* The pointer's rotation accumulates instead of being reset to each
             position's own angle. Jumping from +150deg to -150deg is one step
             clockwise on the dial, but as a plain value it reads as 300deg the
             other way, and the knob would spin the long way round the face. */
          this.turn = startPos ? parseFloat(startPos.dataset.angle) : 0;
          this.facing = this.turn;

          this.positions.forEach((pos) => {
            const index = parseInt(pos.dataset.mode, 10);

            pos.addEventListener('click', () => this.select(index, true));
            pos.addEventListener('focus', () => this.select(index));

            if (this.canHover) {
              pos.addEventListener('mouseenter', () => this.select(index));
            }

            pos.addEventListener('keydown', (event) => {
              let step = 0;
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') step = 1;
              if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') step = -1;
              if (!step) return;

              event.preventDefault();
              const at = this.ring.indexOf(pos);
              this.ring[(at + step + this.ring.length) % this.ring.length].focus();
            });
          });

          if (this.canHover) {
            this.panels.forEach((panel) => {
              const index = parseInt(panel.dataset.mode, 10);
              panel.addEventListener('mouseenter', () => this.select(index));
            });
          }

          this.select(start);
        }

        select(index, reveal) {
          this.positions.forEach((pos) => {
            const on = pos.dataset.mode === String(index);
            pos.classList.toggle('is-active', on);
            pos.setAttribute('aria-pressed', String(on));

            if (on && this.pointer) this.point(parseFloat(pos.dataset.angle));
          });

          let active = null;
          this.panels.forEach((panel) => {
            const on = panel.dataset.mode === String(index);
            panel.classList.toggle('is-active', on);
            if (on) active = panel;
          });

          /* Only the stacked fallback needs this: there the description sits
             below the dial and can be off screen, so the tap would look like it
             did nothing. In the dial layout the description is already beside
             the marker, and scrolling would fight the tap. "nearest" moves the
             page only when the panel is actually out of view. */
          if (reveal && active && this.classList.contains('upr-dial--m-stack')) {
            const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            active.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' });
          }
        }

        point(angle) {
          /* Wrap the difference into -180..180 so the knob always takes the
             short way round, then add it to the running total. */
          const delta = ((angle - this.facing + 540) % 360) - 180;

          this.turn += delta;
          this.facing = angle;
          this.pointer.style.setProperty('--upr-dial-a', this.turn + 'deg');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
